import styled, { css } from 'styled-components/macro';
import { FlexAlignCenter } from '../../../../shared-styles/flex';

export const TrackingQueueTableContainer = styled.div`
  width: 100%;
  height: calc(100% - 50px);

  &.ag-theme-alpine {
    .ag-header {
      background: ${({ theme }) => theme.palette.custom.headerLightBlue};
      border-bottom: 3px solid ${({ theme }) => theme.palette.blue[100]};
    
      .ag-pinned-left-header {
        border-right-width: 2px;
      }

      .ag-header-cell {
        padding: 0 ${({ theme }) => theme.spacing(10)};
        border-right: 0.5px solid ${({ theme }) => theme.palette.lightGray[75]};

        &.column-header {
          font-size: 12px;
          font-weight: ${({ theme }) => theme.typography.weight.regular};
          color: ${({ theme }) => theme.palette.darkBlue[100]};
          font-family: ${({ theme }) => theme.typography.fonts.default};

          &.no-right-border {
            border-right: none;
          }
        }
      }
    }

    .ag-cell {
      line-height: 36px;
      border: none;
      border-right: 0.5px solid ${({ theme }) => theme.palette.lightGray[75]};

      &.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {
        border-right: 2px solid #BABFC7;
      }

      &.standard-cell {
        display: block;
        padding: 0 ${({ theme }) => theme.spacing(10)};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &.no-right-border {
          border-right: none;
        }

        &.ag-cell-focus:not(.ag-cell-range-selected) {
          border: none;
          border-right: 0.5px solid ${({ theme }) => theme.palette.lightGray[75]};

          &.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {
            border-right: 2px solid #BABFC7;
          }
        }
      }

      &.indicator-cell {
        ${FlexAlignCenter}
        padding: 0 ${({ theme }) => theme.spacing(10)};
        border-right: none;

        &.ag-cell-focus:not(.ag-cell-range-selected) {
          border: none;
        }
      }
    }

    .ag-row {
      border-color: ${({ theme }) => theme.palette.lightGray[75]};
      
      &.ag-row-selected {
        background: ${({ theme }) => theme.palette.lightBlue[25]};
      }

      &.ag-row-hover {
        background: ${({ theme }) => theme.palette.lightBlue[50]};
      }
    }
  }
`;

export const LastFetched = styled.p`
  text-align: right;
  margin-bottom: ${(props) => props.theme.spacing(5)};
  padding-right: ${(props) => props.theme.spacing(8)};
`;

export const NumRows = styled.p`
  margin-bottom: ${(props) => props.theme.spacing(5)};
`;

export const NoRowsOverlay = css`
  font-family: Open Sans;
  font-size: 14px;
  position:absolute;
  top: 0;
  margin-top: 100px;
`;
